var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('PageWithIcon',{attrs:{"titleDescription":"Whoops","textDescription":"Sorry, we can’t find that page! Don’t worry though, everything is still AWESOME!","icon":"question"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }